import Vue from 'vue';
import moment from 'moment'

Vue.filter('cnpj', valor => {
    return valor.substring(0, 2) + '.' + valor.substring(2, 5) + '.' + valor.substring(5, 8) + '/' + valor.substring(8, 12) + '-' + valor.substring(12, 14);
});
Vue.filter('cpf', valor => {
    return valor.substring(0, 3) + '.' + valor.substring(3, 6) + '.' + valor.substring(6, 9) + '-' + valor.substring(9, 11);
});
Vue.filter('currency', valor => {
    return 'R$ ' + valor.toLocaleString();
});

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY hh:mm');
    }
});